import http from '@/biz/http.mjs'

export default async (prjId, sVer) => {
    const url = sVer ?
        `/prjs/${prjId}/${sVer}/info`
        :
        `/prjs/${prjId}/info`

    const {
        desgAcc,
        pblType,
        prjName,
        prjNo,
        prjTypeCode,
        rev,
        subTypeCode,
        typeName,
    } = await http.get(url)

    return {
        desgAcc,
        pblType,
        prjName,
        prjNo,
        prjTypeCode,
        rev,
        subTypeCode,
        typeName,
    }
}
